const DEFAULT_DATA = {
    pageContent: [
        {
            __component: 'sections.hero',
            badge: 'FİYATLANDIRMA',
            badge_en: 'PRICING',
            title: 'İhtiyacınıza Uygun Planı Seçin',
            title_en: 'Choose the Plan That Fits Your Needs',
            description: 'ISO 27001 uyumluluk yolculuğunuza uygun planı seçin. Tüm planlarda 14 gün ücretsiz deneme.',
            description_en: 'Pick the right plan for your ISO 27001 compliance journey. 14-day free trial on all plans.',
        },
        {
            __component: 'sections.pricing-section',
            plans: [
                {
                    id: 1,
                    name: 'Başlangıç',
                    name_en: 'Starter',
                    description: 'Küçük ekipler ve startuplar için temel ISO 27001 uyumluluk araçları.',
                    description_en: 'Basic ISO 27001 compliance tools for small teams and startups.',
                    priceMonthly: '₺2.990',
                    priceYearly: '₺2.480',
                    buttonLabel: '14 Gün Ücretsiz Dene',
                    buttonLabel_en: 'Try Free for 14 Days',
                    isPopular: false,
                    features: [
                        { text: 'Varlık Envanteri (50 varlığa kadar)', text_en: 'Asset Inventory (Up to 50 assets)', available: true },
                        { text: 'Risk Değerlendirme Modülü', text_en: 'Risk Assessment Module', available: true },
                        { text: 'Temel Politika Şablonları', text_en: 'Basic Policy Templates', available: true },
                        { text: '2 Kullanıcı', text_en: '2 Users', available: true },
                        { text: 'E-posta Desteği', text_en: 'Email Support', available: true },
                        { text: 'Denetim Yönetimi', text_en: 'Audit Management', available: false },
                        { text: 'API Entegrasyonu', text_en: 'API Integration', available: false },
                        { text: 'Özel Raporlama', text_en: 'Custom Reporting', available: false },
                    ]
                },
                {
                    id: 2,
                    name: 'Profesyonel',
                    name_en: 'Professional',
                    description: 'Büyüyen şirketler için kapsamlı uyumluluk ve denetim araçları.',
                    description_en: 'Comprehensive compliance and audit tools for growing companies.',
                    priceMonthly: '₺7.990',
                    priceYearly: '₺6.630',
                    buttonLabel: '14 Gün Ücretsiz Dene',
                    buttonLabel_en: 'Try Free for 14 Days',
                    isPopular: true,
                    features: [
                        { text: 'Varlık Envanteri (Sınırsız)', text_en: 'Asset Inventory (Unlimited)', available: true },
                        { text: 'Risk Değerlendirme Modülü', text_en: 'Risk Assessment Module', available: true },
                        { text: 'Tüm Politika Şablonları', text_en: 'All Policy Templates', available: true },
                        { text: '10 Kullanıcı', text_en: '10 Users', available: true },
                        { text: 'Denetim Yönetimi', text_en: 'Audit Management', available: true },
                        { text: 'ISO 27001 Kontrol Takibi', text_en: 'ISO 27001 Control Tracking', available: true },
                        { text: 'API Entegrasyonu', text_en: 'API Integration', available: false },
                        { text: 'Özel Raporlama', text_en: 'Custom Reporting', available: false },
                    ]
                },
                {
                    id: 3,
                    name: 'Kurumsal',
                    name_en: 'Enterprise',
                    description: 'Büyük kuruluşlar ve çok lokasyonlu yapılar için tam kapsamlı çözüm.',
                    description_en: 'Full-scale solution for large organizations and multi-location structures.',
                    priceMonthly: 'Özel Fiyat',
                    priceMonthly_en: 'Custom Price',
                    buttonLabel: 'Teklif Alın',
                    buttonLabel_en: 'Get a Quote',
                    isPopular: false,
                    features: [
                        { text: 'Varlık Envanteri (Sınırsız)', text_en: 'Asset Inventory (Unlimited)', available: true },
                        { text: 'Sınırsız Kullanıcı', text_en: 'Unlimited Users', available: true },
                        { text: 'Denetim Yönetimi', text_en: 'Audit Management', available: true },
                        { text: 'ISO 27001 Kontrol Takibi', text_en: 'ISO 27001 Control Tracking', available: true },
                        { text: 'API Entegrasyonu', text_en: 'API Integration', available: true },
                        { text: 'Özel Raporlama & Dashboard', text_en: 'Custom Reporting & Dashboard', available: true },
                        { text: 'Sınırsız Doküman Depolama', text_en: 'Unlimited Document Storage', available: true },
                        { text: '7/24 Öncelikli Destek', text_en: '24/7 Priority Support', available: true },
                    ]
                }
            ]
        },
        {
            __component: 'sections.comparison-section',
            title: 'Planları Karşılaştırın',
            title_en: 'Compare Plans',
            subtitle: 'Hangi planın size uygun olduğuna karar verin.',
            subtitle_en: 'Decide which plan is right for you.',
            rows: [
                { id: 1, feature: 'Varlık Yönetimi', feature_en: 'Asset Management', starter: '50 Varlık', starter_en: '50 Assets', pro: 'Sınırsız', pro_en: 'Unlimited', enterprise: 'Sınırsız', enterprise_en: 'Unlimited' },
                { id: 2, feature: 'Kullanıcı Sayısı', feature_en: 'Number of Users', starter: '2', pro: '10', enterprise: 'Sınırsız', enterprise_en: 'Unlimited' },
                { id: 3, feature: 'Risk Değerlendirme', feature_en: 'Risk Assessment', starter: 'true', pro: 'true', enterprise: 'true' },
                { id: 4, feature: 'Politika Şablonları', feature_en: 'Policy Templates', starter: 'Temel', starter_en: 'Basic', pro: 'Tümü', pro_en: 'All', enterprise: 'Tümü + Özel', enterprise_en: 'All + Custom' },
                { id: 5, feature: 'Denetim Yönetimi', feature_en: 'Audit Management', starter: 'false', pro: 'true', enterprise: 'true' },
                { id: 6, feature: 'ISO 27001 Kontrol Takibi', feature_en: 'ISO 27001 Control Tracking', starter: 'false', pro: 'true', enterprise: 'true' },
                { id: 7, feature: 'API Entegrasyonu', feature_en: 'API Integration', starter: 'false', pro: 'false', enterprise: 'true' },
                { id: 8, feature: 'Özel Raporlama', feature_en: 'Custom Reporting', starter: 'false', pro: 'false', enterprise: 'true' },
                { id: 9, feature: 'Doküman Depolama', feature_en: 'Document Storage', starter: '5 GB', pro: '50 GB', enterprise: 'Sınırsız', enterprise_en: 'Unlimited' },
                { id: 10, feature: 'Destek', feature_en: 'Support', starter: 'E-posta', starter_en: 'Email', pro: 'Öncelikli', pro_en: 'Priority', enterprise: '7/24 Özel', enterprise_en: '24/7 Custom' },
            ]
        },
        {
            __component: 'sections.faq-section',
            title: 'Sık Sorulan Sorular',
            title_en: 'Frequently Asked Questions',
            subtitle: 'Aklınızdaki soruları yanıtlayalım.',
            subtitle_en: 'Let us answer your questions.',
            items: [
                {
                    id: 1,
                    question: 'Planlar arasında geçiş yapabilir miyim?',
                    question_en: 'Can I switch between plans?',
                    answer: 'Evet, istediğiniz zaman planınızı yükseltebilir veya düşürebilirsiniz. Yükseltme anında aktif olur, düşürme ise mevcut fatura döneminin sonunda geçerli olur.',
                    answer_en: 'Yes, you can upgrade or downgrade your plan at any time. Upgrades take effect immediately, while downgrades apply at the end of the current billing cycle.'
                },
                {
                    id: 2,
                    question: 'Ücretsiz deneme süresi var mı?',
                    question_en: 'Is there a free trial period?',
                    answer: 'Evet, tüm planlar için 14 günlük ücretsiz deneme sunuyoruz. Kredi kartı gerekmez.',
                    answer_en: 'Yes, we offer a 14-day free trial for all plans. No credit card required.'
                },
                {
                    id: 3,
                    question: 'Yıllık ödeme yaparsam ne kadar tasarruf ederim?',
                    question_en: 'How much do I save with annual billing?',
                    answer: 'Yıllık ödeme seçeneğinde aylık ödemeye kıyasla yaklaşık %17 tasarruf edersiniz.',
                    answer_en: 'With the annual payment option, you save approximately 17% compared to monthly billing.'
                },
                {
                    id: 4,
                    question: 'Kurumsal plan için özel fiyatlandırma nasıl işliyor?',
                    question_en: 'How does custom pricing work for the Enterprise plan?',
                    answer: 'Kurumsal plan, şirketinizin büyüklüğüne, kullanıcı sayısına ve ihtiyaçlarınıza göre özelleştirilen bir fiyatlandırma modeline sahiptir. Demo talep edin, ekibimiz size özel teklif hazırlasın.',
                    answer_en: 'The Enterprise plan has a pricing model customized to your company size, number of users, and specific needs. Request a demo, and our team will prepare a custom quote for you.'
                },
                {
                    id: 5,
                    question: 'Verilerimi nasıl güvende tutuyorsunuz?',
                    question_en: 'How do you keep my data secure?',
                    answer: 'Tüm veriler AES-256 şifrelemesiyle korunmakta, ISO 27001 sertifikalı altyapıda saklanmaktadır. KVKK ve GDPR uyumluluğu sağlanmaktadır.',
                    answer_en: 'All data is protected with AES-256 encryption and stored on ISO 27001 certified infrastructure. KVKK and GDPR compliance is ensured.'
                }
            ]
        },
        {
            __component: 'sections.cta',
            Title: 'Hâlâ Kararsız mısınız?',
            Title_en: 'Still Undecided?',
            Description: 'Uzman ekibimiz size en uygun planı bulmak için ücretsiz danışmanlık sunar.',
            Description_en: 'Our expert team offers free consultancy to find the best plan for you.',
            primaryButtonText: 'Ücretsiz Demo Alın',
            primaryButtonText_en: 'Get Free Demo',
            secondaryButtonText: 'Satışla Görüşün',
            secondaryButtonText_en: 'Talk to Sales',
        }
    ]
};

export default DEFAULT_DATA;